function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 *  UMSModal 作为是渲染一个 cn 域名下的 iframe。iframe 的作用是初始化 交易 payment SDK，再走 UMS 支付流程。
 */
import React, { useState } from 'react';
import UMSShell from './components/UMSShell';
import { useConfigAtomValues, useStateAtomValues, useStateAtom, useDataAtomValues } from '../../state';
import { usePayChannelId } from '../../hooks';
import { CURRENCY_CNY } from '../../constants/currency';
import { useEventAtom, EEvent } from '../../events';
import { EPayMethodType } from '../../constants';
var UMSModal = function UMSModal(props) {
  var _useConfigAtomValues = useConfigAtomValues(),
    billId = _useConfigAtomValues.billId,
    bizType = _useConfigAtomValues.bizType,
    subBizType = _useConfigAtomValues.subBizType,
    merchantNo = _useConfigAtomValues.merchantNo,
    countryCode = _useConfigAtomValues.countryCode,
    onSuccess = _useConfigAtomValues.onSuccess,
    env = _useConfigAtomValues.env,
    language = _useConfigAtomValues.language,
    appId = _useConfigAtomValues.appId,
    onCancelPay = _useConfigAtomValues.onCancelPay,
    theme = _useConfigAtomValues.theme,
    email = _useConfigAtomValues.email;
  var _useDataAtomValues = useDataAtomValues(),
    payRetryTime = _useDataAtomValues.payRetryTime;
  // NOTE: config state 里的 onCancelPay 和 usePayHandler 传入的 onPayCancel 要怎么区分使用场景？
  var onPayFail = props.onPayFail,
    onPayCancel = props.onPayCancel;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    billIdInRealTime = _useState2[0],
    setBillIdInRealTime = _useState2[1];
  var _useEventAtom = useEventAtom(),
    event$ = _useEventAtom.event$;
  // 事件监听
  event$ === null || event$ === void 0 ? void 0 : event$.useSubscription(function (subscription) {
    var type = subscription.type,
      payload = subscription.payload;
    // 启动 UMS 支付流程，开始请求 token 接口，UMSShell 组件开始渲染。
    if (type === EEvent.ON_PAY_WITH_UMS) {
      setVisible(true);
      // 接收「在还没账单 id 的时候，通过接口创建的 billId 」
      setBillIdInRealTime(payload.billId);
    }
  });
  var _useStateAtomValues = useStateAtomValues(),
    payMethod = _useStateAtomValues.payMethod;
  var _useStateAtom = useStateAtom(),
    _useStateAtom2 = _slicedToArray(_useStateAtom, 2),
    setStateAtom = _useStateAtom2[1];
  var _usePayChannelId = usePayChannelId(),
    payChannel = _usePayChannelId.channelId;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var handleClose = function handleClose() {
    setStateAtom(function (draft) {
      draft.payLoading = false;
    });
    setVisible(false);
  };

  // 是否关闭支付弹窗的时候调用取消的api
  var isInvokeCancelApiOnClose = function isInvokeCancelApiOnClose() {
    if (typeof (onCancelPay === null || onCancelPay === void 0 ? void 0 : onCancelPay.invokeCancelApiOnClose) === 'function') {
      return onCancelPay.invokeCancelApiOnClose({
        billId: billId,
        payMethod: EPayMethodType.UnionPayCard
      });
    }
    return false;
  };
  var handlePayFail = function handlePayFail(payload) {
    setStateAtom(function (draft) {
      draft.payLoading = false;
    });
    onPayFail(payload);
  };
  var handlePayCancel = function handlePayCancel() {
    onPayCancel === null || onPayCancel === void 0 ? void 0 : onPayCancel({
      invokeCancelApi: isInvokeCancelApiOnClose()
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, visible && /*#__PURE__*/React.createElement(UMSShell, {
    appId: appId,
    bizType: bizType,
    subBizType: subBizType,
    merchantNo: merchantNo,
    countryCode: countryCode,
    payChannel: payChannel,
    billId: billId,
    payMethod: payMethod,
    priceCurrencyCode: CURRENCY_CNY,
    billIdInRealTime: billIdInRealTime,
    env: env,
    language: language,
    onPayFail: handlePayFail,
    onSuccess: onSuccess,
    closeModal: handleClose,
    onPayCancel: handlePayCancel,
    theme: theme,
    payRetryTime: payRetryTime,
    email: email
  }));
};
export default UMSModal;